"use strict";

export default class Config {
  static clientFetchTimeoutMs = 3000;
  static fetchPageTimeoutMs = 3000;
}
